import React, { ReactNode } from 'react';

import { FadeInComponent } from '@/components/FadeInComponent';
import { UserPermissionToggle } from '@/core/users/UserPermissions/UserPermissionToggle';

export type PermissionOption = {
  label: string;
  helperLabel?: string;
  isSelected: boolean;
  validators?: Array<{
    isValid: boolean;
    error: string;
  }>
}
type PermissionOptions = {
  [key: string]: PermissionOption;
}
type Props<T extends PermissionOptions> = {
  title: string;
  description: string;
  options: T;
  unavailableMessage?: ReactNode;
  disabledMessage?: string;
  onSelect: (option: keyof T) => void;
}
export function ProductPermissionRow<T extends PermissionOptions> ({ title, description, options, unavailableMessage, disabledMessage, onSelect }: Props<T>) {
  return (
    <>
      <FadeInComponent className="col-start-3">
        <h2 className="font-medium">{ title }</h2>
        <p className="text-sm font-light">{ description }</p>
      </FadeInComponent>
      {unavailableMessage ? unavailableMessage : (
        <FadeInComponent className="flex col-span-3">
          {Object.keys(options).map(key => {
            const option = options[key]!;
            return (
              <UserPermissionToggle
                key={key}
                isSelected={option.isSelected}
                disabledMessage={disabledMessage}
                helperLabel={option.helperLabel}
                onClick={() => onSelect(key)}
                error={option.validators?.find(({ isValid }) => !isValid)?.error}
              >
                { option.label }
              </UserPermissionToggle>
            );
          })}
        </FadeInComponent>
      )}
    </>
  );
}
